module.exports = __webpack_public_path__ + "static/media/valvoline.1f025144.png";